<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
  <g>
    <rect width="32" height="32" fill="none"/>
    <g>
      <path class="filled" d="M25.021,6.979a12.758,12.758,0,1,0,0,18.042A12.758,12.758,0,0,0,25.021,6.979ZM17.8,23.125H14.2v-3.6h3.6Zm0-7.151H14.2V8.423h3.6Z" fill="#e83434"/>
      <rect class="cutout" x="14.2" y="8.423" width="3.6" height="7.551" fill="#fff"/>
      <rect class="cutout" x="14.2" y="19.525" width="3.6" height="3.6" fill="#fff"/>
    </g>
  </g>
</svg>
